import axios from "axios";
const state = {
    productos:[]
};
const getters = {};

const actions = {
    getProductos( {commit} ){
        axios
        .get("https://torstdio.site/api/v1/producto/all")
        .then(response => {
            commit('setProductos', response.data);
        });
    }
};

const mutations = {
    setProductos(state, data){
        state.productos = data;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}